import { render, staticRenderFns } from "./Market.vue?vue&type=template&id=5a611637&scoped=true"
import script from "./Market.vue?vue&type=script&lang=js"
export * from "./Market.vue?vue&type=script&lang=js"
import style0 from "./Market.vue?vue&type=style&index=0&id=5a611637&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a611637",
  null
  
)

export default component.exports